import { handleMessageChange } from "./handleMessageChange";

export function handleUpdateAllCardsComponent(
  selectedNode,
  componentType,
  newData,
  nodes,
  setNodes,
  setCards,
) {
  const updatedCards = selectedNode.data.cards.map((card) => {
    // Vérifie que la card possède bien des composants
    if (!card.components || !Array.isArray(card.components)) return card;
    
    // Met à jour tous les composants de la card qui ont le type recherché
    const updatedComponents = card.components.map((component) => {
      if (component.type === componentType) {
        return { ...component, ...newData };
      }
      return component;
    });

    return { ...card, components: updatedComponents };
  });

  setCards(updatedCards);
  handleMessageChange("cards", updatedCards, nodes, setNodes);
}
